const entityTypeToPathMap = new Map<
  "Place" | "Event" | "Tour" | "Goal" | "FeedPost" | "Challenge" | "SelfGuided",
  string
>([
  ["Place", "places"],
  ["Event", "events"],
  ["Tour", "tours"],
  ["Goal", "goals"],
  ["FeedPost", "feed_posts"],
  ["Challenge", "tours"],
  ["SelfGuided", "tours"],
]);

const getEntityUrlPath = (
  slug: string,
  id: number,
  entityType:
    | "Place"
    | "Event"
    | "Tour"
    | "Goal"
    | "FeedPost"
    | "Challenge"
    | "SelfGuided",
) => {
  const path = entityTypeToPathMap.get(entityType);
  if (!path) {
    return "/";
  }

  if (entityType === "FeedPost") {
    return `/${path}/${id}`;
  }

  return `/${path}/${slug}`;
};

export { getEntityUrlPath };
